import { render, staticRenderFns } from "./PolicyPage.vue?vue&type=template&id=dd61870a&scoped=true"
import script from "./PolicyPage.vue?vue&type=script&lang=js"
export * from "./PolicyPage.vue?vue&type=script&lang=js"
import style0 from "./PolicyPage.vue?vue&type=style&index=0&id=dd61870a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd61870a",
  null
  
)

export default component.exports